import { Action } from '@ngrx/store';

export enum SpinnerctionsTypes {
  EnableSpinner = '[Spinner] Enable Spinner',
  DisableSpinner = '[Spinner] Disable Spinner',
}

export class EnableSpinner implements Action {
  readonly type = SpinnerctionsTypes.EnableSpinner;
}

export class DisableSpinner implements Action {
  readonly type = SpinnerctionsTypes.DisableSpinner;
}

export type SpinnerActions = EnableSpinner | DisableSpinner;
